<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener('DOMContentLoaded', function() {
  const wrappers = document.querySelectorAll('.custom-location-wrapper');

  wrappers.forEach(wrapper => {
    const toggle = wrapper.querySelector('.menu-toggle');
    const menu = wrapper.querySelector('.location-submenu');

    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      menu.classList.toggle('active');
    });

    // Click ngoài để đóng
    document.addEventListener('click', function(e) {
      if (!wrapper.contains(e.target)) {
        menu.classList.remove('active');
      }
    });
  });
});
